<script setup lang="ts">
import type { Option } from '@/modules/common/types/option.type.ts';
import UiChip from '@/modules/ui/components/ui/UiChip.vue';

const { options = [] } = defineProps<{
  options: Option[];
  clickable?: boolean;
}>();

defineEmits<{
  click: [event: MouseEvent, option: Option];
  close: [event: MouseEvent, option: Option];
}>();
</script>

<template>
  <ul class="ui-chip-list">
    <UiChip
      v-for="option in options"
      :key="option.code"
      tag="li"
      closable
      :clickable="clickable"
      @click="$emit('click', $event, option)"
      @close="$emit('close', $event, option)"
    >
      <slot v-bind="option">
        {{ $maybeT(option.label) }}
      </slot>
    </UiChip>
  </ul>
</template>

<style scoped lang="scss">
.ui-chip-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
</style>
